import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';

import { toggleOlxProPopup } from '../../core/actions';
import { getOlxProPopup } from '../../core/selectors';
import OlxProPopup from './OlxProPopup';

const mapDispatchToProps = { onClose: toggleOlxProPopup };
const mapStateToProps = state => ({ visible: getOlxProPopup(state) });
const changeCurrentStep = branch(
  ({ visible }) => !visible,
  renderNothing,
);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  changeCurrentStep,
)(OlxProPopup);
